/**
 * The different types of content in the content array returned.
 */
export const CONTENT_TYPE = {
  SPLIT: 1,
  ITEM: 2,
  SWITCH: 3,
};
